<div id="demo" [innerHTML]="(data$ | async)?.content"></div>